import { gql } from "graphql-request";

const SERVER_DELETE_MILESTONE = gql`
  mutation SERVER_DeleteMilestone($id: ID!) {
    deleteMilestone(id: $id)
  }
`;
export default SERVER_DELETE_MILESTONE;